import React from "react";
import img1 from "../img/img1.jpg"
import img2 from "../img/img2.jpg"
import img3 from "../img/img3.jpg"
import img4 from "../img/img4.jpg"
const Sdata = [
      {
            imgsrc:img1,
            title:"Web development",
      },
      {
            imgsrc:img2,
            title:'App Development',
      },
      {
            imgsrc:img1,
            title:'Software Development',
      },
      {
            imgsrc:img4,
            title:'Digital Marketing',
      },
      {
            imgsrc:img1,
            title:'Marketing',
      },
      {
            imgsrc:img2,
            title:'Blockchain Development',
      },

]

export default Sdata;